var render = function () {
  var _this = this;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-draggable-resizable', {
    staticClass: "tag",
    attrs: {
      "w": _vm.size.width,
      "h": _vm.size.height,
      "x": _vm.axis.x,
      "y": _vm.axis.y,
      "z-index": 9,
      "draggable": false,
      "resizable": false
    }
  }, [_vm.value.type === 'text-employer' ? _c('div', {
    staticClass: "field-input-wrap employerTag"
  }, [_c('v-text-field', {
    staticClass: "v-input--small",
    attrs: {
      "readonly": "",
      "flat": "",
      "solo": ""
    },
    model: {
      value: _vm.content,
      callback: function callback($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1) : _vm._e(), _vm.value.type === 'text-employee' ? _c('div', {
    staticClass: "field-input-wrap employeeTag"
  }, [_c('v-text-field', {
    staticClass: "v-input--small",
    attrs: {
      "outlined": "",
      "placeholder": "텍스트를 입력해주세요"
    },
    on: {
      "change": _vm.update
    },
    model: {
      value: _vm.content,
      callback: function callback($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1) : _vm._e(), _vm.value.type === 'check' ? _c('div', {
    staticClass: "field-input-wrap employeeTag"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('v-checkbox', {
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.update
    },
    model: {
      value: _vm.content,
      callback: function callback($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1)]) : _vm._e(), _vm.value.type === 'canvas' ? _c('div', {
    staticClass: "field-input-wrap employeeTag"
  }, [!_vm.show ? _c('p', {
    on: {
      "mouseover": function mouseover() {
        _this.show = true;
      }
    }
  }, [_vm._v("전자서명을 해주세요")]) : _c('canvas', {
    ref: "myCanvas",
    attrs: {
      "width": _vm.size.width,
      "height": _vm.size.height
    },
    on: {
      "mousedown": _vm.beginDrawing,
      "mousemove": _vm.keepDrawing,
      "mouseup": _vm.stopDrawing,
      "touchstart": _vm.startTouching,
      "touchmove": _vm.moveTouching,
      "touchend": _vm.stopTouching
    }
  })]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }